export const MAX_GAME_TITLE = 100;
export const MAX_GAME_TAGLINE = 250;
export const MAX_GAME_DESC = 2000;
export const MAX_GAME_PUBLISHER = 70;
